import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import styled, { css } from "styled-components";
import Container from "./Container";
import { transformImageUrl } from "./SafeSiteImage";

const HeroStyles = styled.section`
  ${({ ...props }) => css`
    background-color: ${props.theme.colors.primary};
    padding: 32px 0;
    background-image: url(${props.$mobileBackgroundImage});
    background-size: cover;
    background-position: center;
    background-blend-mode: multiply;

    h1,
    p {
      max-width: 500px;
      color: #fff;
    }

    h1 {
      text-align: center;
    }

    p {
      display: none;
    }

    @media (min-width: ${props.theme.breakpoints.md}) {
      padding: 64px 0;

      h1 {
        margin-bottom: 16px;
        text-align: left;
      }

      p {
        display: block;
      }
    }

    @media (min-width: ${props.theme.breakpoints.xl}) {
      background-color: #fff;
      background-image: url(${props.$desktopBackgroundImage}),
        linear-gradient(to right, ${props.theme.colors.primary} 50%, white 50%);
    }
  `}
`;

const HeroTextStyles = styled.div`
  ${({ ...props }) => css`
    @media (min-width: ${props.theme.breakpoints.lg}) {
    }
  `}
`;

export const Hero = ({ heading, text, desktopImage, mobileImage }) => {
  const { site } = useStaticQuery(graphql`
    query SiteUrlQuery {
      site {
        siteMetadata {
          siteUrl
        }
      }
    }
  `)
  
  const mobileBackgroundImage = mobileImage ? transformImageUrl({ siteUrl: site.siteMetadata.siteUrl, imageUrl: mobileImage, width: 1400 }) : null;
  const desktopBackgroundImage = desktopImage ? transformImageUrl({ siteUrl: site.siteMetadata.siteUrl, imageUrl: desktopImage, width: 1920 }) : null;

  return (
    <HeroStyles
      $mobileBackgroundImage={mobileBackgroundImage}
      $desktopBackgroundImage={desktopBackgroundImage}
    >
      <Container>
        <HeroTextStyles>
          <h1>{heading}</h1>
          <p>{text}</p>
        </HeroTextStyles>
      </Container>
    </HeroStyles>
  );
};
